var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-select',{ref:"field",attrs:{"id":_vm.identifier,"name":_vm.name,"value":_vm.value,"empty-value":_vm.emptyValue,"empty-label":_vm.emptyLabel,"options":_vm.filtered_options,"disabled":_vm.disabled,"required":_vm.required},on:{"search":_vm.search,"input":_vm.pick}})
}
var staticRenderFns = []

export { render, staticRenderFns }